import { twMerge } from 'tailwind-merge';
import { LockIcon } from '@/icons';
import { classes } from './utils';

export interface StripeNoteProps {
  className?: string;
}

export default function StripeNote({ className }: StripeNoteProps) {
  return (
    <div className={twMerge(classes.note, className)}>
      <LockIcon />
      <span className={classes.label}>Payments secured by Stripe</span>
    </div>
  );
}
